import useQuery from 'hooks/useQuery';
import useSearchWords from 'hooks/useSearchWords';
import { QueryType } from 'store/slices/query';

export type TableStringHook = string[];

export default function useTableString(queryType: QueryType): TableStringHook {
  const [query] = useQuery(queryType);
  const searchWords = useSearchWords(query);
  return searchWords;
}
